module.exports = __webpack_public_path__ + "img/review_illustration.8a3c422f.svg";